var tagalogTranslation = {
    translations: {
        common: {
            goBack: "Bumalik",
            showMore: "Lakihan ang nakikita",
            showLess: "Bawasan ang nakikita",
        },
        a11y: {
            skipToContent: "Lumaktaw sa pangunahing nilalaman",
            helpAbout: "Tulong tungkol sa {{topic}}",
            copyToClipboard: "Kopyahin ang {{label}} sa clipboard",
            previewMaterial: "I-preview ang {{title}}",
            ballotsTable: "Mga balota",
            ballotLocatorTabs: "Mga seksyon ng ballot locator",
            ballotIdLabel: "Ballot ID",
            votingProgress: "Progreso ng pagboto",
            stepOf: "Hakbang {{current}} ng {{total}}",
            selectUpTo_one: "Pumili ng hanggang {{count}} opsyon",
            selectUpTo_many: "Pumili ng hanggang {{count}} na opsyon",
            selectUpTo_other: "Pumili ng hanggang {{count}} na opsyon",
            selectExactly_one: "Pumili ng {{count}} opsyon",
            selectExactly_many: "Pumili ng {{count}} na opsyon",
            selectExactly_other: "Pumili ng {{count}} na opsyon",
            selectBetween: "Pumili sa pagitan ng {{min}} at {{max}} na opsyon",
        },
        candidatesList: {
            collapseToggle: "I-toggle ang listahan {{listTitle}}",
            showCandidates: "Ipakita ang mga kandidato",
            hideCandidates: "Itago ang mga kandidato",
            selectedCandidates_one: "{{count}} kandidatong napili",
            selectedCandidates_many: "{{count}} kandidatong napili",
            selectedCandidates_other: "{{count}} kandidatong napili",
            expandAll: "Palawakin lahat",
            collapseAll: "Bawasan lahat",
        },
        breadcrumbSteps: {
            electionList: "Listahan ng mga Balota",
            ballot: "Balota",
            review: "Suriin",
            confirmation: "Kumpirmasyon",
            audit: "Audit",
        },
        footer: {
            poweredBy: "Pinapagana ng <1></1>",
        },
        contest: {
            acclamation: {
                description: "Ang paligsahang ito ay napagpasyahan sa pamamagitan ng aklamasyon. Ang mga kandidato nito ay nahalal nang walang botohan, kaya walang opsyong mapipili at walang botong naitatala.",
            },
        },
        votingScreen: {
            backButton: "Bumalik",
            reviewButton: "Susunod",
            clearButton: "Burahin ang mga napili",
            ballotHelpDialog: {
                title: "Impormasyon: Screen ng Balota",
                content: "Ipinapakita sa screen na ito ang mga paligsahan na maaari mong botohan. Maaari kang pumili sa pamamagitan ng pag-activate ng checkbox sa kanang bahagi ng Kandidato/Sagot. Upang i-reset ang iyong mga pagpili, i-click ang “<b>Burahin ang mga napili</b>” na button, upang pumunta sa susunod na hakbang, i-click ang “<b>Susunod</b>” na button sa ibaba.",
                ok: "OK",
            },
            nonVotedDialog: {
                title: "Di-wasto o blangkong boto",
                content: "Ang ilan sa iyong mga sagot ay magreresulta sa pagkaka-invalidate o pagkakaroon ng blangko sa balota sa isa o higit pang mga paligsahan.",
                ok: "Bumalik at suriin",
                continue: "Ipagpatuloy",
                cancel: "Kanselahin",
            },
            warningDialog: {
                title: "Suriin ang iyong balota",
                content: "Ang iyong balota ay naglalaman ng mga pagpili na maaaring mangailangan ng iyong pansin (tulad ng pagpili ng mas kaunting opsyon kaysa sa pinapayagan). Ang iyong balota ay wasto at biblangin ayon sa iyong isinumite.",
                ok: "Bumalik at suriin",
                continue: "Magpatuloy",
                cancel: "Kanselahin",
            },
            blankBallotDialog: {
                title: "Wala kang napiling kandidato",
                content: "Wala kang ginawang pagpili. Ang iyong balota ay isusumite bilang blangkong balota, na isang wasto at sinasadyang pagpili at ibibilang bilang ganoon.",
                continue: "Magpatuloy",
                cancel: "Kanselahin",
            },
        },
        startScreen: {
            startButton: "Simulan ang Pagboto",
            declineToVoteButton: "Tumangging bumoto",
            declineToVoteDialog: {
                title: "Kumpirmahin ang pagtangging bumoto",
                content: "Sigurado ka bang nais mong tumangging bumoto?<br />Dadalhin ka diretso sa review at mase-save ang iyong status ng partisipasyon bilang <b>Tumangging bumoto</b>.",
                continue: "Tumangging bumoto",
                cancel: "Kanselahin",
            },
            instructionsTitle: "Mga Tagubilin",
            instructionsDescription: "Sundin ang mga hakbang na ito upang ikaw ay makaboto:",
            step1Title: "1. Piliin ang iyong mga sagot",
            step1Description: "Pumili sa bawat paligsahan isa-isa habang ipinapakita ang mga ito. Maaari mong i-edit ang iyong balota hanggang handa ka nang magpatuloy.",
            step2Title: "2. Suriin ang iyong balota",
            step2Description: "Kapag ikaw ay kontento na sa iyong mga napili, aming i-eencript ang iyong balota at ipapakita sa iyo ang huling pagsusuri ng iyong mga napili. Makakatanggap ka rin ng natatanging tracker ID para sa iyong balota.",
            step3Title: "3. I-submit ang iyong balota",
            step3Description: "I-submit ang iyong balota: Sa wakas, maaari mo nang i-submit ang iyong balota upang ito ay tamang maitala. Maaari mo ring piliing i-audit at tiyakin na ang iyong balota ay tama ang pagkakalista at pagkaka-encrypt.",
        },
        reviewScreen: {
            acclamation: {
                title: "Napagpasyahan sa pamamagitan ng aklamasyon",
                helpDialog: {
                    title: "Impormasyon: Aklamasyon",
                    content: "Ipinapakita sa screen na ito ang napagpasyahan sa pamamagitan ng aklamasyon. Dahil walang opsyong mapipili, walang balotang isusumite at walang maberipika pagkatapos.",
                    ok: "OK",
                },
                description: "Suriin ang napagpasyahan sa pamamagitan ng aklamasyon sa halalang ito. Walang balotang isusumite.",
                finishButton: "Tapusin",
            },
            title: "Suriin ang iyong balota",
            description: "Upang baguhin ng iyong mga napili, i-click ang “<b>I-edit ang balota</b>” na button, upang kumpirmahin ang iyong mga napili, i-click ang “<b>I-submit ang iyong balota</b>” na button sa ibaba, at upang i-audit ang iyong balota i-click ang “<b>I-audit ang balota</b>” na button sa ibaba.",
            descriptionNoAudit: "Upang baguhin ng iyong mga napili, i-click ang “<b>I-edit ang balota</b>” na button, upang kumpirmahin ang iyong mga napili, i-click ang “<b>I-submit ang iyong balota</b>” na button sa ibaba.",
            backButton: "I-edit ang balota",
            castBallotButton: "I-submit ang iyong balota",
            auditButton: "I-audit ang balota",
            copyBallotId: "Kopyahin ang ballot ID",
            ballotIdCopied: "Nakopya ang ballot ID",
            ballotIdCopyError: "Hindi makopya ang ballot ID",
            reviewScreenHelpDialog: {
                title: "Impormasyon: Screen ng Pagsusuri",
                content: "Maaari mo ditong suriin ang iyong mga napili bago i-submit ang iyong balota.",
                ok: "OK",
            },
            ballotIdHelpDialog: {
                title: "Hindi pa na-submit ang boto",
                content: "<p>Ito ang iyong Ballot Tracker ID, ngunit <b>hindi pa nai-submit ang iyong boto</b>. Kung susubukan mong i-track ang balota, hindi mo ito mahahanap.</p><p>Ang dahilan kung bakit ipinapakita namin ang Ballot Tracker ID sa yugtong ito ay upang masuri mo ang pagiging tama ng naka-encrypt na balota bago ito i-submit.</p>",
                ok: "Tinatanggap ko na HINDI pa nai-susubmit ang aking boto",
                cancel: "Kanselahin",
            },
            auditBallotHelpDialog: {
                title: "Nais mo bang i-audit ang balota?",
                content: "<p>Pakitandaan na ang pag-audit ng iyong balota ay magpapawalang-bisa dito, at kakailanganin mong magsimulang muli sa proseso ng pagboto. Sa proseso ng audit, maari mong tiyakin na ang iyong balota ay tamang naka-encode, ngunit ito ay nangangailangan ng mga advanced na teknikal na hakbang. Inirerekomenda naming magpatuloy ka lang kung ikaw ay kumpiyansa sa iyong kakayahang teknikal. Kung nais mo lamang i-submit ang iyong balota, i-click ang <u>Kanselahin</u> upang bumalik sa screen ng pagsusuri ng balota.</p>",
                ok: "Oo, nais kong IBASURA ang aking balota upang i-audit ito",
                cancel: "Kanselahin",
            },
            confirmCastVoteDialog: {
                title: "Sigurado ka bang nais mong i-submit ang iyong boto?",
                content: "Ang iyong boto ay hindi na maaring baguhin kung ikaw ang magkumpirma.",
                ok: "Oo, nais kong I-SUBMIT ang aking boto",
                cancel: "Kanselahin",
            },
            confirmCastBlankBallotDialog: {
                title: "Sigurado ka bang nais mong magsumite ng blangkong balota?",
                content: "Wala kang napiling kandidato. Pagkatapos mong kumpirmahin, ang iyong balota ay isusumite bilang blangko.",
                ok: "Oo, nais kong isumite ang aking blangkong balota",
                cancel: "Kanselahin",
            },
            unfilledContestsDialog: {
                title: "May mga pagpiling hindi napunan",
                content: "Maaari mong iwanang blangko ang isang posisyon o pumili ng mas kaunting kandidato. Suriin ang sumusunod bago magpatuloy.",
                selected: "{{selected}} sa {{max}} ang napili",
                nothingSelected: "Walang boto para sa posisyong ito",
                ok: "Magpatuloy sa mga pagpiling ito",
                cancel: "Suriin ang mga pinili",
            },
            error: {
                NETWORK_ERROR: "Nagkaroon ng problema sa network. Pakisubukan ulit mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
                UNABLE_TO_FETCH_DATA: "Nagkaroon ng problema sa pagkuha ng data. Pakisubukan ulit mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
                LOAD_ELECTION_EVENT: "Hindi ma-load ang kaganapan ng halalan. Pakisubukan ulit mamaya.",
                CAST_VOTE: "Nagkaroon ng hindi inaasahang error habang bumoboto. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_CheckStatusFailed: "Hindi pinapayagan ng halalan ang pagboto. Ang halalan ay maaaring sarado, naka-archive, o maaari kang bumoto sa labas ng itinakdang panahon.",
                CAST_VOTE_AreaNotFound: "Nagkaroon ng error habang bumoboto: Hindi natagpuan ang lugar. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_InternalServerError: "Nagkaroon ng internal na error habang bumoboto. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_QueueError: "Nagkaroon ng problema sa pagproseso ng iyong boto. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_Unauthorized: "Hindi ka awtorisadong bumoto. Pakikontak ang suporta para sa tulong.",
                CAST_VOTE_ElectionEventNotFound: "Hindi matagpuan ang kaganapang elektoral. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_ElectoralLogNotFound: "Hindi matagpuan ang iyong tala ng pagboto. Pakikontak ang suporta para sa tulong.",
                CAST_VOTE_CheckPreviousVotesFailed: "Nagkaroon ng error habang sinusuri ang iyong status sa pagboto. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_GetClientCredentialsFailed: "Nabigo sa pag-verify ng iyong mga kredensyal. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_GetAreaIdFailed: "Nagkaroon ng error sa pag-verify ng iyong lugar ng pagboto. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_GetTransactionFailed: "Nagkaroon ng error sa pagproseso ng iyong boto. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_DeserializeBallotFailed: "Nagkaroon ng error sa pagbasa ng iyong balota. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_DeserializeContestsFailed: "Nagkaroon ng error sa pagbasa ng iyong mga napili. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_PokValidationFailed: "Nabigo sa pag-validate ng iyong boto. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_UuidParseFailed: "Nagkaroon ng error sa pagproseso ng iyong kahilingan. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_unexpected: "Nagkaroon ng hindi kilalang error habang bumoboto. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_timeout: "May error sa timeout sa pagboto. Pakisubukang muli mamaya o makipag-ugnayan sa support para sa tulong.",
                CAST_VOTE_InsertFailedExceedsAllowedRevotes: "Lumampas ka na sa limitasyon ng muling pagboto. Pakisubukang muli mamaya o makipag-ugnayan sa support para sa tulong.",
                CAST_VOTE_CheckRevotesFailed: "Lumampas ka na sa pinapayagang bilang ng muling pagboto. Pakisubukang muli mamaya o makipag-ugnayan sa support para sa tulong.",
                CAST_VOTE_CheckVotesInOtherAreasFailed: "Nakaboto ka na sa ibang lugar. Pakisubukang muli mamaya o makipag-ugnayan sa support para sa tulong.",
                CAST_VOTE_UnknownError: "Nagkaroon ng hindi kilalang error habang bumoboto. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                NO_BALLOT_SELECTION: "Walang estado ng pagpili para sa halalan na ito. Pakitiyak na tama ang iyong pagpili o makipag-ugnayan sa helpdesk.",
                NO_BALLOT_STYLE: "Walang estilo ng balota. Pakikontak ang helpdesk.",
                NO_AUDITABLE_BALLOT: "Walang balota na maaring suriin. Pakikontak ang helpdesk.",
                INCONSISTENT_HASH: "Nagkaroon ng error kaugnay sa proseso ng pag-hash ng balota. BallotId: {{ballotId}} ay hindi tugma sa sinusuring Hash ng Balota: {{auditableBallotHash}}. Pakireport itong isyu sa helpdesk.",
                ELECTION_EVENT_NOT_OPEN: "Ang kaganapan ng halalan ay sarado na. Pakikontak ang helpdesk.",
                PARSE_ERROR: "Nagkaroon ng error sa pag-parse ng balota. Pakisubukan ulit mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
                DESERIALIZE_AUDITABLE_ERROR: "Nagkaroon ng error sa pag-deserialize ng sinusuring balota. Pakisubukan ulit mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
                DESERIALIZE_HASHABLE_ERROR: "Nagkaroon ng error sa pag-deserialize ng hashable na balota. Pakisubukan ulit mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
                CONVERT_ERROR: "Nagkaroon ng error sa pag-convert ng balota. Pakisubukan ulit mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
                SERIALIZE_ERROR: "Nagkaroon ng error sa pag-serialize ng balota. Pakisubukan ulit mamaya o makipag-ugnayan sa helodesk para sa tulong.",
                UNKNOWN_ERROR: "Nagkaroon ng error. Pakisubukan ulit mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
                REAUTH_FAILED: "Nabigo ang authentication. Pakisubukan muli o makipag-ugnayan sa helpdesk para sa tulong.",
                SESSION_EXPIRED: "Ang iyong session ay nag-expire na. Pakisubukan muli mula sa simula.",
                CAST_VOTE_BallotIdMismatch: "Hindi tumutugma ang ballot ID sa ibinotong boto.",
                CAST_VOTE_BallotStyleMismatch: "Hindi tumutugma ang iyong ballot sa kasalukuyang nailathala para sa halalang ito. Paki-reload ang page at pakisubukang muli, o makipag-ugnayan sa suporta para sa tulong.",
                SESSION_STORAGE_ERROR: "Hindi magamit ang session storage. Pakisubukang muli o makipag-ugnayan sa support.",
                PARSE_BALLOT_DATA_ERROR: "Nagkaroon ng error sa pag-parse ng data ng balota. Pakisubukang muli mamaya o makipag-ugnayan sa support para sa tulong.",
                NOT_VALID_BALLOT_DATA_ERROR: "Ang data ng balota ay hindi wasto. Pakisubukang muli mamaya o makipag-ugnayan sa support para sa tulong.",
                FETCH_DATA_TIMEOUT_ERROR: "May error sa timeout sa pagkuha ng data. Pakisubukang muli mamaya o makipag-ugnayan sa support para sa tulong.",
                TO_HASHABLE_BALLOT_ERROR: "May error sa pag-convert sa hashable na balota. Pakisubukang muli mamaya o makipag-ugnayan sa support para sa tulong.",
                INTERNAL_ERROR: "Nagkaroon ng internal error habang nagboboto. Pakisubukang muli mamaya o makipag-ugnayan sa support para sa tulong.",
            },
            declineToVote: "Tumangging bumoto",
            blankBallot: "Blangkong balota",
        },
        confirmationScreen: {
            acclamation: {
                title: "Napagpasyahan sa pamamagitan ng aklamasyon",
                description: "Lahat ng paligsahan sa halalang ito ay napagpasyahan sa pamamagitan ng aklamasyon, kaya walang balotang isinumite at walang ballot ID na masusubaybayan.",
                helpDialog: {
                    title: "Impormasyon: Aklamasyon",
                    content: "Lahat ng paligsahan sa halalang ito ay napagpasyahan sa pamamagitan ng aklamasyon: ang mga kandidato nito ay nahalal nang walang botohan. Dahil walang balotang isinumite, walang ballot ID, resibo, o QR code na maaaring i-verify.",
                    ok: "OK",
                },
            },
            title: "Ang iyong boto ay nai-submit na",
            description: "Ang code ng kumpirmasyon sa ibaba ay nagpapatunay na <b>ang iyong balota ay matagumpay na nai-submit</b>. Maaari mong gamitin ang code na ito upang tiyakin na ang iyong balota ay nabilang.",
            blankBallot: {
                description: "Ang iyong balota ay naisumite bilang blangko, na isang wasto at sinasadyang pagpili.",
            },
            ballotId: "ID ng Balota",
            printButton: "I-print",
            finishButton: "Tapos na",
            remainingElectionsError: "Hindi namin masuri kung mayroon ka pang ibang eleksiyong maaaring botohan. Pakisubukang muli.",
            retryButton: "Subukang muli",
            verifyCastTitle: "Tiyakin na ang iyong balota ay nai-submit",
            verifyCastDescription: "Maaari mong tiyakin na ang iyong balota ay nai-submit nang tama anumang oras gamit ang sumusunod na QR code:",
            confirmationHelpDialog: {
                title: "Impormasyon: Screen ng Kumpirmasyon",
                content: "Ipinapakita ng screen na ito na ang iyong boto ay matagumpay na nai-submit. Ang impormasyong sa pahinang ito ay nagtitiyak na ang balota ay nai-submit sa ballot box, ang prosesong ito ay maaaring isagawa anumang oras sa panahon ng pagboto at pagkatapos na maisara ang Eleksyon.",
                ok: "OK",
            },
            demoPrintDialog: {
                title: "Pagpi-print ng balota",
                content: "Ang pagpi-print ay hindi pinapayagan sa demo mode",
                ok: "OK",
            },
            demoBallotUrlDialog: {
                title: "ID ng Balota",
                content: "Hindi maaaring gamitin ang code, hindi pinapayagan sa demo mode.",
                ok: "OK",
            },
            ballotIdHelpDialog: {
                title: "Impormasyon: ID ng Balota",
                content: "Ang ID ng Balota ay isang code na maari mong gamitin upang hanapin ang iyong balota sa ballot box, ang ID na ito ay natatangi at hindi naglalaman ng impormasyon tungkol sa iyong mga napili.",
                ok: "OK",
            },
            ballotIdDemoHelpDialog: {
                title: "Impormasyon: Ballot ID",
                content: "<p>Ang Ballot ID ay isang code na maari mong gamitin upang hanapin ang iyong balota sa ballot box, ang ID na ito ay natatangi at hindi naglalaman ng impormasyon tungkol sa iyong mga napili.</p><p><b>Paalala:</b> Ang voting booth na ito ay para sa layuning demonstrasyon lamang. Ang iyong boto ay HINDI pa naipapasa.</p>",
                ok: "OK",
            },
            errorDialogPrintBallotReceipt: {
                title: "Error",
                content: "Nagkaroon ng error, pakisubukan muli",
                ok: "OK",
            },
            demoQRText: "Ang ballot tracker ay hindi gumagana sa demo mode",
        },
        auditScreen: {
            printButton: "I-print",
            restartButton: "Simulan ang Pagboto",
            title: "Suriin ang Iyong Balota",
            description: "Upang i-verify ang iyong balota, mangyaring sundin ang mga hakbang sa ibaba:",
            step1Title: "1. I-download o kopyahin ang sumusunod na impormasyon",
            step1Description: "Ang iyong <b>Ballot ID</b> na makikita sa taas ng screen at ang iyong naka-encrypt na balota sa ibaba:",
            step1HelpDialog: {
                title: "Kopyahin ang Naka-encrypt na Balota",
                content: "Maaari mong i-download o kopyahin ang iyong naka-encrypt na balota upang suriin ang balota at tiyakin na ang naka-encrypt na nilalaman ay naglalaman ng iyong mga pinili.",
                ok: "OK",
            },
            downloadButton: "I-download",
            step2Title: "2. I-verify ang iyong balota",
            step2Description: "<VerifierLink>Access sa ballot verifier</VerifierLink>, isang bagong tab ang magbubukas sa iyong browser.",
            step2HelpDialog: {
                title: "Tutorial sa Pagsusuri ng Balota",
                content: "Upang suriin ang iyong balota, kailangan mong sundin ang mga hakbang na ipinapakita sa tutorial. Kasama rito ang pag-download ng isang desktop application na ginagamit upang i-verify ang naka-encrypt na balota nang hiwalay mula sa website.",
                ok: "OK",
            },
            bottomWarning: "Para sa mga dahilan ng seguridad, kapag sinusuri mo ang iyong balota, kailangan itong ipawalang-bisa. Upang magpatuloy sa proseso ng pagboto, kailangan mong i-click ang ‘<b>Simulan ang Pagboto</b>’ sa ibaba.",
        },
        electionSelectionScreen: {
            title: "Listahan ng Balota",
            description: "Pumili ng Balota na nais mong botohan",
            chooserHelpDialog: {
                title: "Impormasyon: Listahan ng Balota",
                content: "Maligayang pagdating sa Voting Booth, ipinapakita ng screen na ito ang listahan ng mga Balota na maaari mong botohan. Ang mga balota na nakalista dito ay maaaring nakabukas para sa pagboto, naka-schedule, o sarado. Magkakaroon ka lamang ng access sa balota kung nakabukas ang panahon ng pagboto.",
                ok: "OK",
            },
            noResults: "Walang mga balota sa ngayon.",
            resultsButton: "Tingnan ang mga resulta",
            demoDialog: {
                title: "Demo Voting Booth",
                content: "Ikaw ay nasa isang demo voting booth. <strong>Ang iyong boto ay HINDI mai-susubmit.</strong> Ang voting booth na ito ay para lamang sa layunin ng demonstrasyon.",
                ok: "Tinatanggap ko na ang aking boto ay hindi mai-susubmit",
            },
            errors: {
                noVotingArea: "Walang nakatalagang lugar ng halalan para sa botante. Mangyaring subukan muli mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
                networkError: "Nagkaroon ng problema sa network. Mangyaring subukan muli mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
                unableToFetchData: "Nagkaroon ng problema sa pagkuha ng data. Mangyaring subukan muli mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
                noElectionEvent: "Walang kaganapan ng halalan. Mangyaring subukan muli mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
                ballotStylesEmlError: "Nagkaroon ng error sa pag-publish ng estilo ng balota. Mangyaring subukan muli mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
                obtainingElectionFromID: "Nagkaroon ng error sa pagkuha ng mga halalan na nauugnay sa mga sumusunod na election IDs: {{electionIds}}. Mangyaring subukan muli mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
            },
            alerts: {
                noElections: "Walang mga halalan na maaari mong botohan. Ito ay maaring dahil walang naka-ugnay na paligsahan sa lugar. Mangyaring subukan muli mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
                electionEventNotPublished: "Ang kaganapan ng halalan ay hindi pa nailathala. Mangyaring subukan muli mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
            },
            materialsGate: {
                instructions: "Kailangan mong basahin ang <MaterialsLink>{{materialsTitle}}</MaterialsLink> bago ka makaboto.",
            },
        },
        errors: {
            page: {
                oopsWithStatus: "Oops! {{status}}",
                oopsWithoutStatus: "Oops! Hindi inaasahang Error",
                somethingWrong: "May nangyaring hindi tama.",
                invalidLoginHintParametersTitle: "Hindi wastong link sa pagboto",
                invalidLoginHintParametersMessage: "Naglalaman ang link na ito ng hindi wastong impormasyon sa pag-login. Humiling ng bagong link at subukan muli.",
                certAuthFailedTitle: "Nabigo ang Pagpapatunay ng Sertipiko",
                certAuthFailedMessage: "Hindi ma-verify ang iyong sertipiko. Pakitiyak na gumagamit ka ng wastong sertipiko ng botante at subukang muli.",
            },
        },
        materials: {
            common: {
                label: "Mga Pangsuportang Materyales",
                back: "Bumalik sa Listahan ng mga Balota",
                close: "Isara",
                preview: "Silipin",
                download: "I-download",
            },
            mandatory: {
                checkboxLabel: "Nabasa ko na ang Mga Pangsuportang Materyales",
                continueButton: "Magpatuloy",
                error: "Nagkaroon ng problema sa pagre-record ng iyong kumpirmasyon. Pakisubukan muli.",
            },
        },
        slates: {
            title: "Mga slate",
            independent: "Independiyente",
            contestMembers: "Mga kandidato ng {{slate}} para sa {{contest}}",
            noCandidate: "Walang kandidato",
            note: "Pinipili ng slate ang mga kandidato nito at iniiwang blangko ang mga posisyong walang kandidato ng slate. Maaari mong baguhin ang anumang pinili anumang oras.",
            coverage: {
                full: "Buong slate",
                singleContest: "{{contest}} lamang",
                partial: "Bahagyang slate",
                everyOffice: "May kandidato para sa bawat posisyon.",
                someOffices: "May kandidato para sa {{offices}}. Blangko ang ibang posisyon.",
                candidates_one: "{{count}} kandidato",
                candidates_other: "{{count}} kandidato",
                offices_one: "{{count}} posisyon",
                offices_other: "{{count}} posisyon",
            },
            candidateList: {
                show: "Ipakita ang mga kandidato",
                hide: "Itago ang mga kandidato",
            },
            tabs: {
                label: "Paraan ng pagpili",
                slates: "Pumili ng slate",
                candidates: "Mga indibidwal na kandidato",
            },
            count: {
                short: "{{selected}} / {{seats}} kandidatong napili",
                long: "· {{selected}} sa {{seats}} kandidatong napili",
                individual: "Mga indibidwal na pinili",
                none: "Walang napiling kandidato",
            },
            allSelections: {
                label: "Ang iyong mga kasalukuyang pinili",
                none: "Walang pinili",
            },
            review: {
                title: "Ang iyong mga pinili",
                of: "sa {{seats}}",
                selected: "Mga kandidatong napili",
                note: "Itinatala ang iyong boto para sa bawat napiling kandidato.",
                contestCount: "{{selected}} sa {{max}} ang napili",
                unfilled: "Walang napiling kandidato",
                editLabel: "Baguhin ang {{contest}}",
            },
            selection: {
                all: "Napili ang lahat ng {{total}}",
                mixed: "Halo · {{selected}} sa {{total}} ang napili",
                partly: "Bahagyang napili · {{selected}} sa {{total}}",
                selected: "Napili",
                edit: "Baguhin ang mga pinili",
            },
            apply: {
                button: "Piliin ang slate",
                buttonLabel: "Piliin ang slate na {{slate}}",
                applied: "Napili ang {{slate}}. Maaari mo pang baguhin ang sinumang kandidato.",
                appliedPartial_one: "Napili ang {{slate}}. Wala itong kandidato para sa {{offices}}, kaya blangko ang posisyong iyon. Maaari mo pang baguhin ang sinumang kandidato.",
                appliedPartial_other: "Napili ang {{slate}}. Wala itong kandidato para sa {{offices}}, kaya blangko ang mga posisyong iyon. Maaari mo pang baguhin ang sinumang kandidato.",
                overMaximum: "Hindi mapipili ang {{slate}}: mayroon itong {{candidates}} kandidato para sa {{contest}}, na nagpapahintulot ng {{max}}. Maaari ka pa ring pumili ng mga kandidato nang isa-isa.",
                unavailable: "Hindi mapipili ang {{slate}} sa balotang ito. Maaari ka pa ring pumili ng mga kandidato nang isa-isa.",
                replaceDialog: {
                    title: "Palitan ang mga piniling ito?",
                    content_one: "Babaguhin ng pagpili sa <strong>{{slate}}</strong> ang sumusunod na posisyon.",
                    content_other: "Babaguhin ng pagpili sa <strong>{{slate}}</strong> ang mga sumusunod na posisyon.",
                    current: "Mga kasalukuyang pinili",
                    blankNote: "Walang kandidato ang {{slate}} para sa ilang posisyon. Magiging blangko ang mga posisyong iyon.",
                    ok: "Palitan ang mga pinili",
                    okOffice: "Palitan ang {{office}}",
                    cancel: "Panatilihin ang aking mga pinili",
                },
            },
            clear: {
                cleared: "Na-clear na ang lahat ng iyong pinili.",
                dialog: {
                    title: "I-clear ang lahat ng iyong pinili?",
                    content: "Aalisin ng pag-clear ang lahat ng pinili sa iyong balota. Magbabago ang mga posisyong ito:",
                    after: "Pagkatapos i-clear",
                    ok: "I-clear ang mga pinili",
                    cancel: "Panatilihin ang aking mga pinili",
                },
            },
            offices: {
                label: "Mga posisyon",
                picker: "Posisyon",
                index: "Posisyon {{index}} sa {{total}}",
                count: "{{selected}}/{{max}}",
                previous: "Nakaraang posisyon",
                next: "Susunod na posisyon",
                last: "Huling posisyon",
                instruction_one: "Pumili ng hanggang {{count}} kandidato. {{selected}} ang napili.",
                instruction_other: "Pumili ng hanggang {{count}} kandidato. {{selected}} ang napili.",
            },
            limit: "Maaari kang pumili ng hanggang {{count}}. Alisin muna ang isang kandidato bago pumili ng iba.",
            view: {
                button: "Tingnan ang slate",
                buttonLabel: "Tingnan ang slate na {{slate}}",
                summary: "{{coverage}} · {{candidates}}",
                select: "Piliin ang slate na ito",
                back: "Bumalik",
            },
            dialog: {
                close: "Isara ang dialog",
            },
            clearContest: {
                button: "I-clear",
                label: "I-clear ang {{contest}}",
                cleared: "Na-clear ang mga pinili para sa {{contest}}.",
            },
        },
        ballotLocator: {
            title: "Hanapin ang Iyong Balota",
            titleResult: "Resulta ng Iyong Paghahanap ng Balota",
            description: "Patunayan na ang iyong balota ay tama na naipasa",
            locate: "Hanapin ang Iyong Balota",
            locateAgain: "Hanapin ang Isa Pang Balota",
            found: "Ang iyong ballot ID {{ballotId}} ay natagpuan",
            notFound: "Ang iyong ballot ID {{ballotId}} ay hindi natagpuan",
            ambiguous: "Higit sa isa sa iyong mga balota ang tumutugma sa {{ballotId}}. Gamitin ang buong Ballot ID.",
            contentDesc: "Ito ang nilalaman ng iyong balota: ",
            wrongFormatBallotId: "Mali ang format para sa Ballot ID",
            ballotIdNotFoundAtFilter: "Hindi natagpuan ang iyong ballot ID sa filter",
            filterByBallotId: "Tumutugma sa Ballot ID",
            totalBallots: "Kumulang mga balota: {{total}}",
            steps: {
                lookup: "Hanapin ang Iyong Balota",
                result: "Resulta",
            },
            titleHelpDialog: {
                title: "Impormasyon: Screen ng Locator ng Balota",
                content: "Sa screen na ito maaring hanapin ng botante ang kaniyang boto gamit ang Ballot ID upang matagpuan ito. Sa ganitong pamamaraan, maaring suriin kung ang balota ay nai-submit nang tama at kung ang naitalang balota ay tumutugma sa encrypted na balota na kanilang ipinadala.",
                ok: "OK",
            },
            tabs: {
                logs: "Logs",
                ballotLocator: "Lokaliseer uw Stembiljet",
            },
            column: {
                statement_kind: "Uri",
                statement_timestamp: "Timestamp",
                username: "Username",
                ballot_id: "Ballot ID",
                message: "Mensahe",
            },
            pagination: {
                rowsPerPage: "Mga hilera bawat pahina:",
                displayedRows: "{{from}}–{{to}} ng {{total}}",
                displayedRowsMoreThan: "{{from}}–{{to}} ng higit sa {{to}}",
                firstPage: "Pumunta sa unang pahina",
                lastPage: "Pumunta sa huling pahina",
                nextPage: "Pumunta sa susunod na pahina",
                previousPage: "Pumunta sa nakaraang pahina",
            },
        },
    },
};
export default tagalogTranslation;
